import React from "react";
import { BtnContainer, Container, EmptyLow } from "./DeviceList.styles";
import { TExtendedMeetingRoom } from "apis/meeting-room-device";
import DeviceListItem from "./DeviceListItem/DeviceListItem";
import UI from "@mile-meeting/mile-ui";

type DeviceListProps = {
  meetingRoomList: TExtendedMeetingRoom[];
};
const DeviceList: React.FC<DeviceListProps> = ({ meetingRoomList }) => {
  const [foldState, setFoldState] = React.useState<"FOLD" | "UNFOLD" | undefined>(undefined);

  return (
    <Container>
      <BtnContainer>
        <UI.Button
          type="outlined"
          title="모두 접기"
          primary={false}
          size="small"
          disabled={meetingRoomList.length === 0}
          onClick={() => {
            if (meetingRoomList.length === 0) return;
            setFoldState("FOLD");
          }}
        />
        <UI.Button
          type="outlined"
          title="모두 펼치기"
          primary={false}
          size="small"
          disabled={meetingRoomList.length === 0}
          onClick={() => {
            if (meetingRoomList.length === 0) return;
            setFoldState("UNFOLD");
          }}
        />
      </BtnContainer>
      {meetingRoomList.length === 0 && (
        <EmptyLow>
          <UI.Icon name="meetingRoom2" color="var(--alias-color-label-alternative)" size={24} />
          <UI.Typography type="body01 normal" fontStyle="regular" color="var(--alias-color-label-normal)">
            태블릿 사용이 활성화되니 회의실이 없습니다. 회의실 등록 및 설정에서 태블릿 사용을 활성화한 후, 조회해
            주세요.
          </UI.Typography>
        </EmptyLow>
      )}
      {meetingRoomList.length > 0 &&
        meetingRoomList.map((meetingRoom) => {
          return (
            <DeviceListItem
              key={meetingRoom.id}
              meetingRoom={meetingRoom}
              foldState={foldState}
              initFoldSate={() => setFoldState(undefined)}
            />
          );
        })}
    </Container>
  );
};

export default React.memo(DeviceList);
